import { Chip, Tooltip } from "@mui/material";
import { Box } from "@mui/system";

interface Tag {
  id: string;
  name: string;
  /** Shown dashed, with a tooltip saying it comes from the waste stream. */
  inherited?: boolean;
}

interface TagsDisplayProps {
  tags: Tag[];
}

/**
 * Display a list of tags as a flexbox of chips.
 */
export function TagsDisplay({ tags }: TagsDisplayProps) {
  if (!tags || tags.length === 0) return null;
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {tags.map((tag) => (
        <Tooltip title={tag.inherited ? `${tag.name} (from waste stream)` : tag.name} key={tag.id}>
          <Chip
            label={tag.name}
            size="small"
            variant="outlined"
            sx={{
              height: 20,
              fontSize: "0.75rem",
              ...(tag.inherited && { borderStyle: "dashed" }),
              "& .MuiChip-label": {
                px: 1,
              },
            }}
          />
        </Tooltip>
      ))}
    </Box>
  );
}
